import React from 'react';
import { Image, Text, Box } from '@wix/design-system';
import { WidgetButton } from '../shared/WidgetButton/WidgetButton';
import s from './PremiumUpsellWidget.module.scss';
import { WithMarkdown } from '../shared/WithMarkdown/WithMarkdown';
import { DefaultImage } from './DefaultImage';
import { useDisabledWidget } from '../../../shared/disabled-widget/useDisabledWidget';
import { WithDisabledControl } from '../../../shared/disabled-widget/WithDisabledControl';
export const PremiumUpsellWidget = _ref => {
  let {
    data,
    context,
    config
  } = _ref;
  const {
    image,
    title,
    text,
    primaryButton,
    secondaryButton
  } = data;
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  const handleButtonClick = function (action, label) {
    if (label === void 0) {
      label = '';
    }
    const handler = effects => {
      const onWidgetActionData = {
        action,
        value: {
          label,
          effects
        }
      };
      context.onWidgetAction(PREMIUM_UPSELL_WIDGET, onWidgetActionData, `${title} ${text}`);
    };
    return handler;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: s.content
  }, /*#__PURE__*/React.createElement("div", {
    className: s.image
  }, image ? /*#__PURE__*/React.createElement(Image, {
    src: image
  }) : /*#__PURE__*/React.createElement(DefaultImage, null)), title && /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    size: "tiny",
    className: s.title
  }, title), text && /*#__PURE__*/React.createElement("div", {
    className: s.text
  }, /*#__PURE__*/React.createElement(WithMarkdown, null, text)), ((primaryButton == null ? void 0 : primaryButton.label) || (secondaryButton == null ? void 0 : secondaryButton.label)) && /*#__PURE__*/React.createElement(Box, {
    gap: "10px",
    direction: "vertical",
    align: "center"
  }, (primaryButton == null ? void 0 : primaryButton.label) && /*#__PURE__*/React.createElement(WithDisabledControl, {
    isDisabled: areControlsDisabled,
    onEnable: enableControls,
    t: context.t
  }, /*#__PURE__*/React.createElement(WidgetButton, {
    respondText: primaryButton == null ? void 0 : primaryButton.respondText,
    webAction: primaryButton == null ? void 0 : primaryButton.webAction,
    context: context,
    icon: primaryButton == null ? void 0 : primaryButton.icon,
    skin: (primaryButton == null ? void 0 : primaryButton.skin) || 'premium',
    sideEffect: primaryButton == null ? void 0 : primaryButton.sideEffect,
    onClick: handleButtonClick('primary_button_click', primaryButton == null ? void 0 : primaryButton.label),
    disabled: areControlsDisabled
  }, primaryButton == null ? void 0 : primaryButton.label)), (secondaryButton == null ? void 0 : secondaryButton.label) && /*#__PURE__*/React.createElement(WithDisabledControl, {
    isDisabled: areControlsDisabled,
    onEnable: enableControls,
    t: context.t
  }, /*#__PURE__*/React.createElement(WidgetButton, {
    respondText: secondaryButton == null ? void 0 : secondaryButton.respondText,
    webAction: secondaryButton == null ? void 0 : secondaryButton.webAction,
    context: context,
    icon: secondaryButton == null ? void 0 : secondaryButton.icon,
    priority: "secondary",
    skin: (secondaryButton == null ? void 0 : secondaryButton.skin) || 'premium',
    sideEffect: secondaryButton == null ? void 0 : secondaryButton.sideEffect,
    onClick: handleButtonClick('secondary_button_click', secondaryButton == null ? void 0 : secondaryButton.label),
    disabled: areControlsDisabled
  }, secondaryButton == null ? void 0 : secondaryButton.label))));
};
export const PREMIUM_UPSELL_WIDGET = 'PREMIUM_UPSELL_WIDGET';
//# sourceMappingURL=PremiumUpsellWidget.js.map